import { fetchAuthSession } from "@aws-amplify/auth";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";

export const useGetRole = () => {
  const { user } = useAuthenticator((context) => [context.user]);

  const [role, setRole] = useState("");
  useEffect(() => {
    async function fetchRole() {
      const auth = await fetchAuthSession();
      const groups = auth.tokens?.idToken?.payload[
        "cognito:groups"
      ] as Array<string>;
      setRole(groups?.[0]);
    }
    if (user) {
      fetchRole();
    } else {
      setRole("");
    }
  }, [user]);

  return { role };
};
